import React from "react";
import { useState, useEffect } from "react";
import "./CarouselSection.scss";
import blueshoe from "../../assets/blueshoe.png";
import redshoe from "../../assets/redshoe.png";
import Header from "../../Sharedcomponents/Header/Header";
import bluebg from "../../assets/bluebg.jpg";
import redbg from "../../assets/redbg.jpg";
import { getAnnouncebyTag } from "../../Services/BackendUrl";
import axios from "axios";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import Marquee from "react-fast-marquee";

const Presale = () => {
  const [announcementMessage, setAnnouncementMessage] = useState([]);

  const products = [
    {
      offer: "Limited Offer",
      sale: "PRE SALE OFF",
      content: `"Limited Time Offer! Don’t miss out on smashing deals! Grab exclusive discounts on rackets, shoes, shuttlecocks, and more. Hurry — stock won’t last!"`,
      img: blueshoe,
    },
    {
      offer: "Limited Offer",
      sale: "NEW ARRIVALS",
      content: `"Limited Time Offer! Don’t miss out on smashing deals! Grab exclusive discounts on rackets, shoes, shuttlecocks, and more. Hurry — stock won’t last!"`,
      img: redshoe,
    },
  ];

  const [currentSlideProduct, setCurrentSlideProduct] = useState(products[0]);
  const [activeIndex, setActiveIndex] = useState(0);

  const productTemplate = (product) => {
    return (
      <div className="product-item">
        <div className="carousel-left">
          <h2>
            {product.offer} <span style={{ color: "orange" }}>.</span>
          </h2>
          <h1 className="pre-sale-head">{product.sale}</h1>
          <p style={{ color: "gray" }}>{product.content}</p>
        </div>
        <div className="carousel-right">
          <img
            style={{
              height: "auto",
              maxWidth: "100%",
              filter: "drop-shadow(10px 15px 20px rgba(0, 0, 0, 9.9))",
            }}
            src={product.img}
            alt="shoe-img"
          />
        </div>
      </div>
    );
  };

  useEffect(() => {
    const getAnnouncement = async () => {
      try {
        const response = await axios.get(getAnnouncebyTag, {
          params: { tag: "Academy" },
        });
        if (
          response.data &&
          Array.isArray(response.data.announcements) &&
          response.data.announcements.length > 0
        ) {
          setAnnouncementMessage(response.data.announcements);
        }
      } catch (error) {
        console.error("Error fetching announcement:", error);
      }
    };
    getAnnouncement();
  }, []);

  return (
    <div className="background-color">
      <div
        className="x-mark"
        style={{
          backgroundImage: `url(${currentSlideProduct?.img === blueshoe ? bluebg : redbg
            })`,
        }}
      >
        X
      </div>

      <Header />

      <div className="scroll-text">
        <div
          style={{
            writingMode: "sideways-lr",
            fontSize: "0.7rem",
            color: "white",
            letterSpacing: "2px",
          }}
        >
          Scroll Down
        </div>
        <div
          style={{
            borderRight: "2px solid white",
            paddingBottom: "20px",
            margin: "10px 0px 0px 7px",
            writingMode: "vertical-lr",
            height: "100px",
          }}
        ></div>
      </div>

      <Swiper
        modules={[Autoplay]}
        autoplay={{ delay: 3000 }}
        loop={true}
        slidesPerView={1}
        onSlideChange={(swiper) => {
          const newIndex = swiper.realIndex;
          setActiveIndex(newIndex);
          setCurrentSlideProduct(products[newIndex]);
        }}
      >
        {products.map((p, i) => (
          <SwiperSlide key={i}>{productTemplate(p)}</SwiperSlide>
        ))}
      </Swiper>

      <div className="carousel-indicators">
        {products.map((_, i) => (
          <span
            key={i}
            className={`indicator-dot ${i === activeIndex ? "active" : ""}`}
          />
        ))}
      </div>

      <div>
        {announcementMessage.length > 0 && (
          <Marquee
            className="homeannouncementss"
            gradient={false}
            speed={80}
            pauseOnHover={true}
          >
            {announcementMessage
              .filter(
                (announce) =>
                  announce.status === "active" &&
                  !announce.message
                    .toLowerCase()
                    .includes("updated court announcement")
              )
              .map((announce, index) => (
                <span
                  key={index}
                  className="marquee"
                  style={{
                    marginRight: "40px",
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                  }}
                >
                  <span>{announce.message}</span>
                  {announce.fileUrl && (
                    <button
                     onClick={() => window.open(`https://docs.google.com/viewer?url=${announce.fileUrl}&embedded=true`, "_blank")}

                      style={{
                        background: "white",
                        color: "black",
                        borderRadius: "5px",
                        padding: "5px 10px",
                        cursor: "pointer",
                        fontWeight: "600",
                        border: "none",
                      }}
                    >
                      View
                    </button>
                  )}
                </span>
              ))}
          </Marquee>
        )}
      </div>
    </div>
  );
};

export default Presale;